<div class="req-data-container pt-4 container">
    <div class="req-data-header">
        <h4 class="app-module-title m-0" *ngIf="allowEmails && !allowPhones && !userHaveEmails">
            <strong>Proporciona tu correo electrónico</strong>
        </h4>
        <h4 class="app-module-title m-0" *ngIf="!allowEmails && allowPhones && !userHavePhones">
            <strong>Proporciona tu núm. de teléfono</strong>
        </h4>
        <h4 class="app-module-title m-0" *ngIf="allowEmails && !allowPhones && userHaveEmails">
            <strong>Selecciona o ingresa tu correo electrónico</strong>
        </h4>
        <h4 class="app-module-title m-0" *ngIf="!allowEmails && allowPhones && userHavePhones">
            <strong>Selecciona o ingresa tu núm. de teléfono</strong>
        </h4>
    </div>
    <div class="req-data-content">
        <ng-container *ngIf="userHaveEmails && allowEmails && !allowPhones && !userNeedNewContact && onContactRequiredScreen">
            <app-profile-info-item *ngFor="let item of emails"
                [emitSelection]="true"
                [isSelected]="item === email"
                title="Correo electrónico"
                [value]="item.email"
                [payload]="item"
                [scope]="1"
                identifier="email"
                [verified]="item.sw_valida === 1"
                [showUnverifiedPill]="true"
                [showUpdateBtn]="false"
                [showDeleteBtn]="item.sw_valida !== 1 && item.sw_primario !== 1"
                [config]="config"
                (selected)="selectedEmail($event)">
            </app-profile-info-item>
        </ng-container>
        <ng-container *ngIf="userHavePhones && allowPhones && !allowEmails && !userNeedNewContact && onContactRequiredScreen">
            <app-profile-info-item *ngFor="let item of phones"
                [emitSelection]="true"
                [isSelected]="item === phone"
                title="Número de teléfono"
                [value]="item.telefono"
                [payload]="item"
                [scope]="1"
                identifier="telefono"
                [verified]="item.sw_valida === 1"
                [showUnverifiedPill]="true"
                [showUpdateBtn]="false"
                [showDeleteBtn]="item.sw_valida !== 1 && item.sw_primario !== 1"
                [config]="config"
                (selected)="selectedPhone($event)">
            </app-profile-info-item>
        </ng-container>
        <ng-container *ngIf="onContactRequiredScreen && userNeedNewContact">
            <div>
                <form class="mt-3" [formGroup]="contactForm">
                    <p class="x-small-label text-uppercase spaced-label">
                        {{
                            (allowEmails && !allowPhones) ? 'Correo electrónico' : 'Num. de teléfono'
                        }}
                    </p>
                    <app-auth-input controlName="account"
                                    [forPhone]="allowPhones && !allowEmails"
                                    [forEmail]="allowEmails && !allowPhones"
                                    [accentColorForIcon]="true">
                    </app-auth-input>
                    <div class="text-danger my-3" *ngIf="contactForm.hasError('accountExists')">
                        <img src="../../../assets/img/error-circle-100.svg"
                             width="32"
                             height="32"
                             alt="Account Error">
                        Esta cuenta ya esta siendo utilizada.
                    </div>
                </form>
            </div>
        </ng-container>
        <ng-container>
            <div class="container">
                <app-sms-verification #contactVerifier
                                      (userHasVerifiedCode)="onUserVerifiedContact($event)">
                </app-sms-verification>
            </div>
        </ng-container>
    </div>
    <div class="req-data-bottom multiple-separation-bottom-actions">
        <button [hidden]="onValidationAccount"
                mat-flat-button
                class="role-action-btn w-100"
                [disabled]="
                    (contactForm.get('account').invalid && !userHavePhones && !userHaveEmails)
                    || (userNeedNewContact && contactForm.hasError('accountExists'))
                    || (contactForm.get('account').invalid && userNeedNewContact)
                    || (contactForm.get('account').invalid && userNeedNewContact)
                    || (phone.telefono === '' && userHavePhones && !userNeedNewContact)
                    || (email.email === '' && userHaveEmails && !userNeedNewContact)"
                (click)="sendCodeForValidation()">
            Continuar
        </button>
        <button *ngIf="(userHaveEmails || userHavePhones) && !userNeedNewContact"
                mat-flat-button
                class="bg-transparent accent-color w-100"
                (click)="onUserRequireAnotherData()">
            {{
                (allowPhones && !allowEmails)
                    ? 'Usar otro num. de teléfono'
                    : 'Usar otro correo electrónico'
            }}
        </button>
        <button *ngIf="(userHaveEmails || userHavePhones) && userNeedNewContact"
                mat-flat-button
                class="bg-transparent accent-color w-100"
                (click)="onUserWantSelectData()">
            {{
            (allowPhones && !allowEmails)
                ? 'Usar num. de teléfono existente'
                : 'Usar correo electrónico existente'
            }}
        </button>
        <button *ngIf="
                (allowEmails && !allowPhones) ||
                (allowPhones && onValidationAccount)
            "
            mat-flat-button
                class="bg-transparent accent-color w-100"
                (click)="skipData()">
            Mas tarde
        </button>
    </div>
</div>

<ng-template #unableToDeliverCode>
    <div class="unable-to-deliver-content p-3">
        <div>
            <p class="medium-text fw-bold m-0 pb-3">No se pudo entregar el codigo</p>
        </div>
        <div>
            <p class="small-label pb-3">Estamos teniendo problemas para entregar el mensaje. Intenta mas tarde o con otra cuenta.</p>
        </div>
        <div>
            <button mat-flat-button
                    class="role-action-btn w-100"
                    (click)="dismissMessage()">
                Aceptar
            </button>
        </div>
    </div>
</ng-template>
